import "jQuery";

'use strict';

(function($) {

    function update_job_display(type) {
        if(type) {
            $('.job-offers .job-offer').hide(0);
            $('.job-offers .job-offer.type-' + type).show(0);
        } else {
            $('.job-offers .job-offer').show(0);
        }
    }

    $(document).ready(function() {
        $('.job-types-tabs').each(function() {
            let $tabs = $(this);
            $('li', $tabs).click(function() {
                $('li', $tabs).not(this).removeClass('active');
                $(this).addClass('active');
                let type = $(this).data('type');
                update_job_display(type);
                if($tabs.hasClass('mobile-subcategories')) {
                    $('.subcategories-title', $tabs).text($(this).text()).click();
                }
            });
        });
    });

})( jQuery );